export function formatPercent(p: number) {
  return p.toFixed(2) + '%';
}
export function extractJsonDate(str: any): Date {
    const d = new Date(parseInt(str.match(/\d+/)[0]) * 1);
    return d;
}
export function getNextMonth(n: number) {
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const d = new Date();
  d.setMonth(new Date().getMonth() + n);
  return monthNames[d.getMonth()];
}

// export function resolveEach(arr: any, ajax: ()=>JQueryPromise<any>)  {
//     return new
// }

export function formatDate(str: string) {
  const d = new Date(str);
  return d.toLocaleString();
}

export function formatNewDate(str: string) {
  return str ? str.substring(0, str.indexOf('T')) : '';
}
export function insertDelimeters(v: number, n: number, x?: number) {
  const re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
  // tslint:disable-next-line:no-bitwise
  return v.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
}
export function roundPrice(num: number) {
  if (('' + num).indexOf('e') === -1) {
    return +(Math.round(parseFloat(num + 'e+' + 2)) + 'e-' + 2);
  } else {
    const arr = ('' + num).split('e');
    let sig = '';
    if (+arr[1] + 2 > 0) {
      sig = '+';
    }
    return +(Math.round(parseFloat(+arr[0] + 'e' + sig + (+arr[1] + 2))) + 'e-' + 2);
  }
}
export function formatPrice(v: any) {
  if (isNaN(v)) {
    return '';
  }
  const result = '$' + insertDelimeters(roundPrice(v), 2);
  return result;
}
export function getParameterByName(name: string) {
    const url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) { return null; }
    if (!results[2]) { return ''; }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
